import type { Video } from './types/global.types';

export function hasVideo(video?: Array<Video>): boolean {
  return !!(
    video &&
    video.length > 0 &&
    (video[0]?.vimeo_url?.length > 0 ||
      (video[0]?.hosted_video && video[0]?.hosted_video?.filename?.length > 0))
  );
}

export function getFallbackVideo(video?: Array<Video>, fallbackVideo?: Array<Video>): Video {
  if (video && hasVideo(video)) {
    return video[0];
  }

  return (fallbackVideo as Array<Video>)[0];
}

export function addImageInVideoObject(video: Video, image?: string): Video {
  if (image && !video?.poster_image?.filename) {
    return {
      ...video,
      poster_image: {
        filename: image,
      },
    };
  }
  return video;
}
